/** 목록 API가 배열을 주므로 정렬·페이지 분할은 보유한 전체 결과에 적용한다. */
import type {
  DataTablePageReq,
  DataTablePageResp,
  DataTableSortState,
  TableRow,
} from "@carbon6/c6-frontend-design";

export const LIST_PAGE_SIZE = 50;

export function paginateRows<Row extends TableRow>(
  rows: readonly Row[],
  request: DataTablePageReq,
  sort: DataTableSortState | null,
): DataTablePageResp<Row> {
  const ordered = sort
    ? [...rows].sort(
        (left, right) => (sort.direction === "asc" ? 1 : -1) * left.compare(right, sort.columnKey),
      )
    : rows;
  const total = ordered.length;
  const page = Math.min(request.page, Math.max(1, Math.ceil(total / request.size)));
  const start = (page - 1) * request.size;
  return { rows: ordered.slice(start, start + request.size), total, page, size: request.size };
}
